import { AnalyticsEvent, CommonPayload, Tracker, convertForRudderstack } from '@water-web/view';
import { CustomerModel } from '@water-web/repository';

export class RudderStackTracker implements Tracker {
  getName(): string {
    return 'RudderStackTracker';
  }

  track(analyticsEvent: AnalyticsEvent, payload: CommonPayload): void {
    const converted = convertForRudderstack(analyticsEvent, payload);

    if (!converted) {
      return;
    }

    window.rudderanalytics?.track(converted.event, converted.payload);
  }

  trackCustomerInfo(customer: CustomerModel): void {
    window.rudderanalytics?.identify(customer.getId(), customer.toJson());
  }

  page(location: string, payload: CommonPayload): void {
    window.rudderanalytics?.page(location, payload);
  }

  identify(customerId: string): void {
    window.rudderanalytics?.identify(customerId);
  }
}
